import React from 'react';
import { BRAND_ORANGE } from '../../../../styles/portalTheme';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';

const MenuSkipConfirmDialog = ({
  open,
  dishCount = 0,
  onClose,
  onRemoveAndSkip,
  onKeepAndSkip,
}) => (
  <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
    <DialogTitle sx={{ fontWeight: 700 }}>Skip menu step</DialogTitle>
    <DialogContent>
      <Typography variant="body2" color="text.secondary">
        {dishCount > 0
          ? `This menu already has ${dishCount} dish${dishCount === 1 ? '' : 'es'} with content. Do you want to remove the existing menu or keep it and continue?`
          : 'This menu has attached content. Do you want to remove it or keep it and continue?'}
      </Typography>
    </DialogContent>
    <DialogActions sx={{ flexDirection: 'column', alignItems: 'stretch', px: 3, pb: 2.5, gap: 1 }}>
      <Button
        variant="contained"
        onClick={onKeepAndSkip}
        sx={{
          textTransform: 'none',
          fontWeight: 600,
          bgcolor: BRAND_ORANGE,
          boxShadow: 'none',
          '&:hover': { bgcolor: 'primary.dark', boxShadow: 'none' },
        }}
      >
        Keep menu and skip
      </Button>
      <Button
        variant="outlined"
        onClick={onRemoveAndSkip}
        sx={{
          textTransform: 'none',
          fontWeight: 600,
          color: BRAND_ORANGE,
          borderColor: BRAND_ORANGE,
          '&:hover': { borderColor: 'primary.dark', bgcolor: 'rgba(224, 104, 10, 0.04)' },
        }}
      >
        Remove menu and skip
      </Button>
      <Button onClick={onClose} sx={{ textTransform: 'none', color: 'text.secondary' }}>
        Cancel
      </Button>
    </DialogActions>
  </Dialog>
);

export default MenuSkipConfirmDialog;
